;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import Button from '@/components/atoms/Button';
import Modal from '@/components/molecules/Modal';
import { CloseIcon } from '@/public/assets/svg';
import { ModalInfoProps } from './types';
const ModalInfo = ({
  isOpen,
  title,
  description,
  onClose,
  buttonText = 'Okay',
  onSubmit
}: ModalInfoProps) => {
  return <Modal {...{
    isOpen,
    onClose
  }} contentClassName="relative p-6 lg:p-10 min-w-[20rem] max-w-120" data-sentry-element="Modal" data-sentry-component="ModalInfo" data-sentry-source-file="index.tsx">
      <div className="flex flex-col items-center">
        <button type="button" className="absolute top-4 right-4 text-gray-600 hover:text-gray-800" onClick={onClose} aria-label="Close">
          <CloseIcon className="h-6 w-6" data-sentry-element="CloseIcon" data-sentry-source-file="index.tsx" />
        </button>
        <h2 className="text-body-3 mb-3 text-center font-bold">{title}</h2>
        <p className="text-body-7 mb-7 text-center">{description}</p>
        <Button onClick={onSubmit || onClose} className="w-41.5" data-sentry-element="Button" data-sentry-source-file="index.tsx">
          {buttonText}
        </Button>
      </div>
    </Modal>;
};
export default ModalInfo;